<template>
  <b-modal
    :id="this.$attrs.id"
    :title="title"
    :header-bg-variant="headerBgVariant"
    :title-class="titleClass"
    size="lg"
  >
    <b-card-text class="m-2 align-center">
      <b-row>
        <b-col :style="confirmationStyles">
          {{ confirmation }}
        </b-col>
      </b-row>
      <b-row v-if="description">
        <b-col :style="descriptionStyles">
          {{ description }}
        </b-col>
      </b-row>
    </b-card-text>
    <template #modal-footer="{ close }">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-button
              v-if="closeButton"
              variant="secondary"
              class="mr-2"
              @click="close"
            >
              {{ closeButton }}
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button
              v-if="okButton"
              type="button"
              :variant="okButtonStyles"
              :disabled="loading"
              @click="$emit('submit')"
            >
              <b-spinner
                v-if="loading"
                class="mr-1"
                small
              />
              {{ okButton }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
import { BButton, BCardText, BCol, BContainer, BModal, BRow, BSpinner } from 'bootstrap-vue'

export default {
  components: {
    BCardText,
    BContainer,
    BCol,
    BRow,
    BButton,
    BModal,
    BSpinner,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    confirmation: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    closeButton: {
      type: String,
      default: 'Cancel',
    },
    okButton: {
      type: String,
      default: 'Proceed',
    },
    okButtonStyles: {
      type: String,
      default: 'primary',
    },
    titleClass: {
      type: String,
      default: '',
    },
    headerBgVariant: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    confirmationStyles: {
      type: String,
      default: '',
    },
    descriptionStyles: {
      type: String,
      default: '',
    },
  },
}
</script>
